import React from "react";
import { Secondary } from "../../ui-components/CustomButton";
import { CircularProgress, Grid, Typography } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useNavigate, useSearchParams } from "react-router-dom";
import GoogleIcon from '../../assets/google_icon.png'
import Cookies from "js-cookie"
import { LoginSocialLinkedin, LoginSocialGoogle } from 'reactjs-social-login';
import { LoginViaEmail } from "api";
import { checkForDomain, getDeviceType, setTokenForAuthorization, captureUtmParams } from "utilities/index";
import { hasPendingSubscriptionIntent } from "utilities/subscriptionIntent";
import { useToast } from "context/ToastContext";

const GoogleLogin = ({ loginMethod, setLoginMethod }) => {
  // const providerCookies = Cookies.get("provider")
  const currentIP = window.location.host;
  const currentLOcation = window.location.pathname;
  const [searchParams, setSearchParams] = useSearchParams()
  const theme = useTheme()
  const { addToast } = useToast()
  const navigate = useNavigate()
  const [provider, setProvider] = React.useState('');
  const [profile, setProfile] = React.useState(null);
  const { mutateAsync: loginViaEmailAsync, status: LoginViaEmailStatus, error: LoginViaEmailError, isLoading, data: loginViaEmailResponse } = LoginViaEmail();

  const onLoginStart = () => {
    setLoginMethod("google");
    // console.log('Login started');
  };

  const onResolve = async ({ provider, data }) => {
    Cookies.remove('userDetails');
    setProvider(provider);
    setProfile(data);
    // const decodedData = jwtDecode(data?.access_token)
    fetch(`https://www.googleapis.com/oauth2/v3/tokeninfo?access_token=${data?.access_token}`).then(response => response.json())
      .then(async (data) => {
        // Cookies.set("userDetails", JSON.stringify({ first_name: data?.given_name, last_name: data?.family_name }))
        setLoginMethod("google");
        await loginViaEmailAsync({
          "email": data?.email,
          ...(searchParams.get("ref") ? { "ref": searchParams.get("ref") } : {}),
      ...(searchParams.get("utm_source") ? { utm_source: searchParams.get("utm_source") } : {}),
      ...(searchParams.get("utm_campaign") ? { utm_campaign: searchParams.get("utm_campaign") } : {}),
          "devices": {
            "device_token": `${Math.random() * 10}`,
            "device_type": getDeviceType()
          },
          "last_login_ip": `${currentIP}`,
          "auth_provider": "google"
        }, {
          onSuccess: (verifyResponse) => {
            captureUtmParams()
            if (!searchParams.get("ref")) {
              Cookies.set("pathname", window.location?.pathname + window.location?.search);
            }
            else{
              Cookies.set("pathname", "/");
            }
            const response = verifyResponse?.data?.data;
            if (response?.userData?.investor_name) {
              addToast(`You are added to ${response?.userData?.investor_name}'s pipeline.`, "success")
            }
            if (currentIP?.includes("localhost")) {
              if (response?.collaborator_data?.connected_id) {
                Cookies.set("X-ST-ID", response?.collaborator_data?.connected_id);
              }
              response?.userData?.token && setTokenForAuthorization(response?.userData?.token);
            }
            // Session to be same for current users:
            if (response?.collaborator_data?.connected_id) {
              Cookies.set("X-ST-ID", response?.collaborator_data?.connected_id, { domain: checkForDomain() });
            }
            response?.userData?.token && setTokenForAuthorization(response?.userData?.token, checkForDomain());
            Cookies.set("email", data?.email);
            if (currentLOcation?.includes("register") && searchParams.get("ref")) {
              Cookies.set("ref", searchParams.get("ref"))
            }
            Cookies.set("provider", "google")
            if (response?.is_profile_completed == true) {
              Cookies.set("is_profile_complete", true, { domain: checkForDomain() })
              if (hasPendingSubscriptionIntent()) {
                navigate("/?upgrade=true");
              }
              else if (Cookies.get("pathname")) {
                navigate(Cookies.get("pathname"));
                Cookies.remove("pathname")
              }
              else {
                navigate(currentLOcation !== "/login" && currentLOcation !== "/verification" && currentLOcation !== "/register" ? currentLOcation : "/");
              }
            }
            else {
              Cookies.set("is_profile_complete", false, { domain: checkForDomain() })
              navigate("/");
              Cookies.set("step", Number(response?.step))
            }
          },
          onError: () => {
            // setEmailError(true);
          }
        });
      })

  };

  const onReject = (err) => {
    console.error('Login failed', err);
  };
  // console.log(isLoading,loginMethod,"loginMethod")

  return (
    <LoginSocialGoogle
      client_id={process.env.REACT_APP_GOOGLE_CLIENT_ID}
      client_secret={process.env.REACT_APP_GOOGLE_CLIENT_SECRET}
      redirect_uri={origin}
      scope="openid profile email"
      onLoginStart={onLoginStart}
      onResolve={onResolve}
      onReject={onReject}
      typeResponse={'accessToken'}
      isOnlyGetToken
    >
      <Secondary
        sx={{ border: `1px solid #E0E0E6`, borderRadius: '10px', height: '54px', marginBottom: { xs: "0rem", sm: 0 } }}
        fullWidth
      >
        {isLoading && loginMethod == "google" ? <CircularProgress sx={{ color: "black", marginInline: 'auto' }} size={'1.4rem'} /> : <Grid
          display={"flex"}
          gap={1}
          flexDirection={"row"}
          alignItems={"center"}
        >
          <img src={GoogleIcon} width={24} height={24} />
          <Typography
            variant="caption"
            sx={{ textTransform: "none", fontWeight: 500, fontSize: '1rem', color: '#344054' }}
          >
            Continue with Google
          </Typography>
        </Grid>}
      </Secondary>
    </LoginSocialGoogle>
  );
};

export default GoogleLogin;